import React from 'react';
import { Container } from './styles';
import { menuListItems } from '../../assets/menu/menuList';
import { Menu } from '../../components/Menu';
import { CustomersTable } from './CustomersTable';

export const Home: React.FC = () => {
  return (
    <Menu links={menuListItems}>
      <Container>
        <CustomersTable/>
      </Container>
    </Menu>
  )
}